import React from "react";
import DidYouKnow from "../components/DidYouKnow";
import DWInfoCard from "../components/DWInfoCard";
import DWQuestionCard from "../components/DWQuestionCard";
import DWReadingCzar from "../components/DWReadingCzar";
import DWSlideCard from "../components/DWSlideCard";
import _ from "lodash";
import { motion } from "framer-motion/dist/framer-motion";
import { divVariants } from "shared/components/animations";
const DW20Reading = ({
  playedCard,
  askedQuestion,
  isCzarPlayer,
  roomId,
  joke,
  currentPlayerCard,
  screens
}) => {
  const czar_instructions_top_text = _.get(
    screens,
    "3_reading .czar  .instructions_top_text  ",
    "READ THE CARD OUT LOUD"
  );
  const czar_instructions_bottom_text = _.get(
    screens,
    "3_reading .czar  .instructions_bottom_text",
    "Tap on cards to flip them and read them out loud"
  );
  const other_instructions_top_text = _.get(
    screens,
    "3_reading .other  .instructions_top_text  ",
    "Wait while the Card Czar reads the played cards"
  );
  const instructions_bottom_text = _.get(
    screens,
    "3_reading .other  .instructions_bottom_text ",
    "Hang tight!"
  );
  return (
    <motion.div
      variants={divVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
      className="dw-playing"
    >
      <div>
        <DWInfoCard
          info1={isCzarPlayer ? "Card Czar" : ""}
          info2={
            isCzarPlayer
              ? czar_instructions_top_text
              : other_instructions_top_text
          }
          styled_info3={
            isCzarPlayer
              ? czar_instructions_bottom_text
              : instructions_bottom_text
          }
        />
        <DWQuestionCard askedQuestion={askedQuestion} />

        {isCzarPlayer ? (
          <DWReadingCzar
            playedCard={playedCard}
            roomId={roomId}
            isReading={true}
          />
        ) : (
          <DWSlideCard
            currentPlayerCard={currentPlayerCard}
            screens={screens}
          />
        )}
      </div>
      <DidYouKnow joke={joke} />
    </motion.div>
  );
};

export default DW20Reading;
